export const accreditedLenderBuilderForMilli = (lender) => {
  const lenderId = Number(lender.ProviderId);
  return {
    lenderId,
    lenderName: lender.ProviderName,
    lenderCode: lender.ProviderName.replace(/ /g, ''),
    key: lenderId,
  };
};
